export default "/images/vendor/flag-icons/flags/1x1/gn.svg?347b60cf985684d7ea4ff2ffae61c549";